import { useRef } from 'react';
import HelperIconWithTooltip from 'src/shared/components/HelperIconWithTooltip';
import { useTranslation } from 'react-i18next';
import { useStyles } from 'src/shared/components/Charts/CircleChart/SingleChart/Legend/styles';

type LegendProps = {
  explanation?: string;
  legend: string;
  colors: string[];
};

const Legend = ({ explanation, legend, colors }: LegendProps) => {
  const { t } = useTranslation(['overview']);
  const ref = useRef<HTMLInputElement>(null);
  const textRef = useRef<HTMLInputElement>(null);
  const classes = useStyles({ colors });

  return (
    <div className={classes.legend}>
      <div className={classes.legendDot} />
      <div ref={ref} className={classes.legendText}>
        <span ref={textRef}>
          {legend}{' '}
          {explanation && <HelperIconWithTooltip className={classes.helperIconTooltipWrapper} title={t(explanation)} />}
        </span>
      </div>
    </div>
  );
};

export default Legend;
